import { blue, grey, orange, red, yellow } from "@material-ui/core/colors";

export const palette = {
	type: "light",
	secondary: blue,

	// Storage UI custom colors
	// Note: Storage UI uses theme.palette.secondary for accent color
	// For alpha/opacity variants, use alpha(color, opacity) in components
	storageUi: {
		// Backgrounds - semantic naming
		backgroundPrimary: grey[100], // Main background
		backgroundSecondary: grey[400], // Lighter background (header, buttons, canvas grid)

		// Status colors (can be overridden from config)
		occupied: "#ff8c8c", // Color for occupied places
        blocked: '#a6a6a6', // Color for blocked places
		empty: "#b7ff7d", // Color for empty places
		emptyTextColor: "#2e7d32", // Text color for empty status

		// Config status colors
		configProduction: "#56d364",
		configDraft: "#8d8d8d",

		// Highlight colors
		highlight: yellow[500], // Blue for highlighting
		highlightOrange: orange[500], // Orange for alternative highlighting

		// Borders
		borderLight: grey[600], // Light border

		// Text colors
		textPrimary: grey[900], // Primary text (almost black)
		textSecondary: grey[600], //  Secondary/disabled text
		textOnSecondary: grey[50], // Text on secondary color background

		// Button hover
		buttonHover: grey[300], // Hover state

		// Error colors
		errorText: red[700], // Error text

		// Area colors (for different zones in visualization)
		areaColors: [
			"#4e79a7",
			"#f28e2b",
			"#e15759",
			"#76b7b2",
			"#59a14f",
			"#edc948",
			"#b07aa1",
			"#ff9da7",
			"#9c755f",
			"#bab0ac",
		],
	},
};
